import React from 'react';
import { Box, Chip, ChipProps } from '@mui/material';
import { getPriorityToken, WORK_PLANS_ACCENT } from './workPlansTokens';

export interface WorkPlansPriorityChipProps extends Omit<ChipProps, 'color'> {
  priority: string;
  filterInactive?: boolean;
  filterActive?: boolean;
  /** Leading dot for filter row */
  showDot?: boolean;
}

export const WorkPlansPriorityChip: React.FC<WorkPlansPriorityChipProps> = ({
  priority,
  filterInactive,
  filterActive,
  showDot,
  label,
  sx,
  ...rest
}) => {
  const t = getPriorityToken(priority);
  const dot = showDot ? (
    <Box
      component="span"
      sx={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        bgcolor: t.stripe,
        mr: 0.75,
        flexShrink: 0,
      }}
    />
  ) : null;

  if (filterInactive) {
    return (
      <Chip
        size="small"
        label={
          showDot ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {dot}
              {label}
            </Box>
          ) : (
            label
          )
        }
        sx={{
          bgcolor: '#ffffff',
          color: '#6B7280',
          border: '1.5px solid #E5E7EB',
          fontSize: '12px',
          fontWeight: 600,
          px: 0.25,
          '& .MuiChip-label': { px: 1.375 },
          ...sx,
        }}
        {...rest}
      />
    );
  }
  if (filterActive) {
    return (
      <Chip
        size="small"
        label={
          showDot ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {dot}
              {label}
            </Box>
          ) : (
            label
          )
        }
        sx={{
          bgcolor: t.chipBg,
          color: t.chipText,
          border: `2px solid ${WORK_PLANS_ACCENT}`,
          fontSize: '12px',
          fontWeight: 600,
          px: 0.25,
          '& .MuiChip-label': { px: 1.375 },
          ...sx,
        }}
        {...rest}
      />
    );
  }
  return (
    <Chip
      size="small"
      label={label}
      sx={{
        bgcolor: t.chipBg,
        color: t.chipText,
        border: '1px solid transparent',
        fontSize: '12px',
        fontWeight: 600,
        ...sx,
      }}
      {...rest}
    />
  );
};
